import { Directive } from "@angular/core";
import { NzTabDirective } from "ng-zorro-antd/tabs";

/** Decorates the `ng-template` tags and reads out the template from it. */
@Directive({
  selector: "[ui-tab]",
  exportAs: "uiTab",
  standalone: true,
})
export class UiTabDirective extends NzTabDirective {}
